import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { DAFTAR_URL, LOGIN_URL } from "../../config/links";

const navLinks = [
    { label: "Beranda", href: "/#beranda", type: "hash" },
    { label: "Tentang", href: "/#tentang", type: "hash" },
    { label: "Game", href: "/#game", type: "hash" },
    { label: "Provider", href: "/#provider", type: "hash" },
    { label: "Blog", href: "/blog", type: "route" },
    { label: "FAQ", href: "/#faq", type: "hash" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const renderLink = (l) => {
        const cls =
            "text-sm text-white/70 hover:text-[#D4AF37] transition-colors";
        const testid = `nav-link-${l.label.toLowerCase()}`;
        if (l.type === "route") {
            return (
                <Link data-testid={testid} to={l.href} className={cls}>
                    {l.label}
                </Link>
            );
        }
        // For hash links, always prefix to root if we're on another page
        const href = pathname === "/" ? l.href.replace(/^\//, "") : l.href;
        return (
            <a data-testid={testid} href={href} className={cls}>
                {l.label}
            </a>
        );
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <nav
                className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 h-20"
                aria-label="Navigasi utama"
            >
                <Link
                    to="/"
                    data-testid="logo-link"
                    className="flex items-center gap-2.5"
                    aria-label="PUSATCUAN Beranda"
                >
                    <img
                        src="/logo.png"
                        alt="Logo PUSATCUAN - Bandar Online 24 Jam"
                        className="h-11 w-11 md:h-12 md:w-12 rounded-full object-contain animate-logo-soft"
                        loading="eager"
                        width="48"
                        height="48"
                    />
                    <span className="text-xl font-semibold tracking-tight text-gold-gradient">
                        PUSATCUAN
                    </span>
                </Link>

                <ul className="hidden md:flex items-center gap-8">
                    {navLinks.map((l) => (
                        <li key={l.label}>{renderLink(l)}</li>
                    ))}
                </ul>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        data-testid="header-login-button"
                        href={LOGIN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white/80 hover:text-white px-4 py-2 rounded-full border border-white/10 hover:border-white/30 transition-all"
                    >
                        Login
                    </a>
                    <a
                        data-testid="header-daftar-button"
                        href={DAFTAR_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-semibold text-black bg-[#D4AF37] hover:bg-[#F3E5AB] px-5 py-2 rounded-full transition-all shadow-gold-glow hover:scale-105"
                    >
                        Daftar Sekarang
                    </a>
                </div>

                <button
                    data-testid="mobile-menu-toggle"
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-white p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/5 px-6 py-6"
                >
                    <ul className="flex flex-col gap-5">
                        {navLinks.map((l) => (
                            <li key={l.label} onClick={() => setOpen(false)}>
                                {renderLink(l)}
                            </li>
                        ))}
                        <li className="flex gap-3 pt-3">
                            <a
                                href={LOGIN_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 text-center text-sm text-white/80 px-4 py-2 rounded-full border border-white/10"
                            >
                                Login
                            </a>
                            <a
                                href={DAFTAR_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex-1 text-center text-sm font-semibold text-black bg-[#D4AF37] px-4 py-2 rounded-full"
                            >
                                Daftar
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
}
